module.exports = __webpack_public_path__ + "static/20141025_105506-1095e6aeb94094dfe0f27ea5e36e16a4.jpg";